import { apiBaseUrl } from './api';
import { types as sdkTypes } from './sdkLoader';

const activeSaleCache = new Map();

export const fetchActiveSales = listingIds => {
  const ids = (listingIds || []).filter(Boolean);
  const cacheKey = ids.slice().sort().join(',');
  if (!activeSaleCache.has(cacheKey)) {
    activeSaleCache.set(
      cacheKey,
      fetch(`${apiBaseUrl()}/api/sales/active?listingIds=${encodeURIComponent(cacheKey)}`, {
        credentials: 'include',
      })
        .then(response => (response.ok ? response.json() : { sales: [] }))
        .then(data => data.sales || [])
        .catch(() => [])
    );
  }
  return activeSaleCache.get(cacheKey);
};

export const fetchSellerSales = () =>
  fetch(`${apiBaseUrl()}/api/sales`, { credentials: 'include' })
    .then(response => {
      if (!response.ok) throw new Error('Unable to load sales.');
      return response.json();
    })
    .then(data => data.sales || []);

export const clearSaleCache = () => activeSaleCache.clear();

export const saleForListing = (sales, listingId) =>
  sales.find(sale => sale.listingId === listingId) || null;

export const salePercentOff = (basePrice, sale) => {
  if (!basePrice || !sale || basePrice.currency !== sale.currency) return null;
  const saleAmount = Number(sale.salePriceSubunits);
  if (!Number.isInteger(saleAmount) || saleAmount <= 0 || saleAmount >= basePrice.amount) return null;
  return Math.round((1 - saleAmount / basePrice.amount) * 100);
};

export const getEffectivePrice = (listing, sale) => {
  const regularPrice = listing?.attributes?.price;
  if (!regularPrice || !sale || sale.currency !== regularPrice.currency) return regularPrice;

  const saleAmount = Number(sale.salePriceSubunits);
  if (!Number.isInteger(saleAmount) || saleAmount <= 0 || saleAmount >= regularPrice.amount) {
    return regularPrice;
  }

  return new sdkTypes.Money(saleAmount, regularPrice.currency);
};
